// requestIdleCallback的兼容性处理

const isSupportIdleCallback = typeof window !== 'undefined' && typeof window.requestIdleCallback === 'function';

export const requestIdleCallback = (
    callback: (deadline?: IdleDeadline) => void,
    options: IdleRequestOptions = { timeout: 0 },
) => {
    if (isSupportIdleCallback) {
        const nativeRequestIdleCallback = window.requestIdleCallback as unknown as (
            callback: (deadline?: IdleDeadline) => void,
            options?: { timeout?: number },
        ) => number;

        const idleHandle = nativeRequestIdleCallback(callback, options);
        return {
            cancel() {
                (window.cancelIdleCallback as unknown as (handle: number) => void)?.(idleHandle);
            },
        };
    }

    const timer = setTimeout(callback, options.timeout);
    return {
        cancel() {
            clearTimeout(timer);
        },
    };
};

if (typeof window !== 'undefined') {
    window.requestIdleCallback = window.requestIdleCallback || requestIdleCallback;
}
